import { createEvent, createStore } from 'effector';


/* 
    PAGE SORT STATES
*/

const localSortInitialState: ILocalSortState = {
  options: [
    { label: 'по стоимости', val: 'price', active: false },
    { label: 'по контрагенту', val: 'buyerable_id', active: false },
    { label: 'по весу', val: 'weight', active: false },
    { label: 'по сумме', val: 'total', active: false },
    { label: 'по дате добавления', val: 'updated_at', active: true },  
  ],
  order: 'desc',
  active: [
    { label: 'активные', value: 'active', active: false },
    { label: 'неактивные', value: 'non_active', active: false },
  ],
  action: [
    { label: 'миксование', value: 'mix', active: false },
    { label: 'осушение', value: 'drain', active: false },
    { label: 'увлажнение', value: 'hydrate', active: false },
  ],
  cultures: [], // тут впоследствии загружаются данные в эффекте
};
export const setSortLocalState = createEvent<ILocalSortState>();

export const $localSort = createStore(localSortInitialState).on(
  setSortLocalState,
  (_p, s) => s,
);

type SortOption = {
  label: string;
  val: string;
  active: boolean;
};

interface SortOption2 extends Omit<SortOption, 'val'> {
  value: string;
}

export interface ILocalSortState {
  options: SortOption[];
  order: 'asc' | 'desc';
  active: SortOption2[];
  action: SortOption2[];
  cultures: SortOption2[];
}

/* 
    PAGE SIDEBAR STATES
*/

export const setSelectedOffers = createEvent<number[]>();

export const $selectedOffers = createStore<number[]>([]).on(setSelectedOffers, (_s, p) => p);
